/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import {
  ResponseDataSelectorObjectCommonData,
  ResponseDataSelectorObjectCommonDataFromJSON,
  ResponseDataSelectorObjectCommonDataFromJSONTyped,
  ResponseDataSelectorObjectCommonDataToJSON
} from './ResponseDataSelectorObjectCommonData'

/**
 *
 * @export
 * @interface ResponseDataSelectorObjectCommon
 */
export interface ResponseDataSelectorObjectCommon {
  /**
   *
   * @type {number}
   * @memberof ResponseDataSelectorObjectCommon
   */
  status?: number
  /**
   *
   * @type {ResponseDataSelectorObjectCommonData}
   * @memberof ResponseDataSelectorObjectCommon
   */
  data?: ResponseDataSelectorObjectCommonData
}

export function ResponseDataSelectorObjectCommonFromJSON(json: any): ResponseDataSelectorObjectCommon {
  return ResponseDataSelectorObjectCommonFromJSONTyped(json, false)
}

export function ResponseDataSelectorObjectCommonFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): ResponseDataSelectorObjectCommon {
  if (json === undefined || json === null) {
    return json
  }
  return {
    status: !exists(json, 'status') ? undefined : json['status'],
    data: !exists(json, 'data') ? undefined : ResponseDataSelectorObjectCommonDataFromJSON(json['data'])
  }
}

export function ResponseDataSelectorObjectCommonToJSON(value?: ResponseDataSelectorObjectCommon | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    status: value.status,
    data: ResponseDataSelectorObjectCommonDataToJSON(value.data)
  }
}
